import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "recursive-element--child"
}
const _hoisted_2 = {
  key: 1,
  class: "recursive-element--child"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_recursive_selector_element = _resolveComponent("recursive-selector-element", true)!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (!_ctx.isFilteredOut && (_ctx.beingSearched || _ctx.hasSearched))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "row justify-left no-wrap full-width",
        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.elementClicked && _ctx.elementClicked(...args)), ["stop","prevent"]))
      }, [
        ((_ctx.isSelectable || (_ctx.isExpandable && !_ctx.showRecords)))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['row no-wrap', { 'rec-lst-item full-width': !(_ctx.isExpandable && _ctx.showRecords) }])
            }, [
              _createVNode(_component_q_checkbox, {
                class: "rec-checkbox unset-items-center",
                "checked-icon": _ctx.hideCheckboxes ? 'done' : undefined,
                "unchecked-icon": _ctx.hideCheckboxes ? 'none' : undefined,
                size: "xs",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
                modelValue: _ctx.selectedModel,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedModel) = $event))
              }, null, 8, ["checked-icon", "unchecked-icon", "modelValue"]),
              (!(_ctx.isExpandable && _ctx.showRecords))
                ? (_openBlock(), _createBlock(_component_q_item_label, {
                    key: 0,
                    color: "accent",
                    style: {"margin-top":"5px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSearchedName, (span, i) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: i,
                          style: _normalizeStyle(span.style)
                        }, _toDisplayString(span.text), 5))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.isExpandable && _ctx.showRecords)
          ? (_openBlock(), _createBlock(_component_q_expansion_item, {
              key: 1,
              "switch-toggle-side": "",
              "expand-icon-toggle": "",
              "model-value": _ctx.hasSearched || (_ctx.beingSearched && _ctx.searchRegex !== undefined) || _ctx.openOnStart,
              dense: true,
              "dense-toggle": true,
              "expand-separator": "",
              icon: "expand_more",
              class: "recursive-element full-width"
            }, {
              header: _withCtx(() => [
                _createVNode(_component_q_item_label, {
                  style: {"margin-top":"6px"},
                  class: "rec-lst-item"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSearchedName, (span, i) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: i,
                        style: _normalizeStyle(span.style)
                      }, _toDisplayString(span.text), 5))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                (_ctx.returnType === 'none')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.theModel[_ctx.nestedKeyName], (child, index) => {
                        return (_openBlock(), _createBlock(_component_recursive_selector_element, {
                          element: child,
                          key: _ctx.parentIdx+'_'+index,
                          "element-chain": [],
                          "parent-idx": index,
                          "is-root": false,
                          "take-ids-only": _ctx.takeIdsOnly,
                          "return-type": _ctx.returnType,
                          "nested-key-name": _ctx.nestedKeyName,
                          "entity-inside-name": _ctx.entityInsideName,
                          "element-type": _ctx.elementType,
                          "allow-multiple": _ctx.allowMultiple,
                          "hide-checkboxes": _ctx.hideCheckboxes,
                          "show-records": _ctx.showRecords,
                          "filter-out-list": _ctx.filterOutList,
                          "parameter-type-name": _ctx.parameterTypeName,
                          "value-type": child.ValueType,
                          "search-regex": _ctx.searchRegex,
                          "filter-string": _ctx.filterString,
                          "parent-included": _ctx.beingSearched,
                          modelValue: _ctx.theModel[_ctx.nestedKeyName][index],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.theModel[_ctx.nestedKeyName][index]) = $event)
                        }, null, 8, ["element", "parent-idx", "take-ids-only", "return-type", "nested-key-name", "entity-inside-name", "element-type", "allow-multiple", "hide-checkboxes", "show-records", "filter-out-list", "parameter-type-name", "value-type", "search-regex", "filter-string", "parent-included", "modelValue", "onUpdate:modelValue"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.element as any)[_ctx.nestedKeyName], (child, index) => {
                        return (_openBlock(), _createBlock(_component_recursive_selector_element, {
                          element: child,
                          key: _ctx.parentIdx+'_'+index,
                          "element-chain": _ctx.returnType === 'chain' ? 
              (_ctx.takeIdsOnly ? (_ctx.elementType === 1 ? [..._ctx.elementChain, child.Id] : (
                _ctx.elementType === 9 ? [..._ctx.elementChain, child[_ctx.entityInsideName].Id] : [..._ctx.elementChain, child])
              ) : [..._ctx.elementChain, child]) : [],
                          "parent-idx": index,
                          "is-root": false,
                          "take-ids-only": _ctx.takeIdsOnly,
                          "return-type": _ctx.returnType,
                          "nested-key-name": _ctx.nestedKeyName,
                          "entity-inside-name": _ctx.entityInsideName,
                          "element-type": _ctx.elementType,
                          "allow-multiple": _ctx.allowMultiple,
                          "hide-checkboxes": _ctx.hideCheckboxes,
                          "show-records": _ctx.showRecords,
                          "filter-out-list": _ctx.filterOutList,
                          "parameter-type-name": _ctx.parameterTypeName,
                          "value-type": child.ValueType,
                          "search-regex": _ctx.searchRegex,
                          "filter-string": _ctx.filterString,
                          "parent-included": _ctx.beingSearched,
                          modelValue: _ctx.theModel,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.theModel) = $event))
                        }, null, 8, ["element", "element-chain", "parent-idx", "take-ids-only", "return-type", "nested-key-name", "entity-inside-name", "element-type", "allow-multiple", "hide-checkboxes", "show-records", "filter-out-list", "parameter-type-name", "value-type", "search-regex", "filter-string", "parent-included", "modelValue"]))
                      }), 128))
                    ]))
              ]),
              _: 1
            }, 8, ["model-value"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}